
let topics = document.querySelectorAll('.static-masonry .item');
Array.prototype.forEach.call(topics, function (item) {
    let overlay = item.querySelector('.uk-overlay');
    let svg = item.querySelector('img.svg-rounded');
    let height = overlay.clientHeight - 1;
    UIkit.svg(svg).svg.then(function (svg) {
        svg.style.bottom = height + "px";
    })
});

